// extracted by mini-css-extract-plugin
export var fadeIn = "_cx-1";
export var modalContent = "_cx-3";
export var overlay = "_cx-0";
export var popoverContent = "_cx-2";
export var results = "_cx-5";
export var searchInputWrapper = "_cx-4";